import React from "react";

export default function AlertToast({ item, onClose }) {
  if (!item) return null;

  const raw = `${item?.type || ""} ${item?.message || ""}`.toLowerCase();
  const danger =
    raw.includes("fire") ||
    raw.includes("화재") ||
    raw.includes("sos") ||
    raw.includes("danger") ||
    raw.includes("위험");

  return (
    <div
      className={`pointer-events-auto w-[380px] max-w-[calc(100vw-32px)] rounded-2xl border p-4 shadow-2xl backdrop-blur ${
        danger
          ? "border-red-200 bg-red-50/95 dark:border-red-800 dark:bg-red-950/85"
          : "border-gray-200 bg-white/95 dark:border-white/10 dark:bg-[#111827]/95"
      }`}
    >
      <div className="flex items-start gap-3">
        <div
          className={`mt-0.5 flex h-10 w-10 items-center justify-center rounded-xl text-sm font-bold text-white ${
            danger ? "bg-red-500" : "bg-blue-600"
          }`}
        >
          {danger ? "!" : "i"}
        </div>

        <div className="min-w-0 flex-1">
          <div
            className={`text-sm font-bold ${
              danger
                ? "text-red-700 dark:text-red-200"
                : "text-gray-900 dark:text-white"
            }`}
          >
            {item.type || "이벤트"}
          </div>
          <div className="mt-1 break-words text-sm text-gray-700 dark:text-gray-200">
            {item.message || "-"}
          </div>
          <div className="mt-2 text-[12px] text-gray-500 dark:text-gray-400">
            {item.displayTime || "-"}
          </div>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="text-gray-400 transition hover:text-gray-700 dark:hover:text-white"
        >
          ✕
        </button>
      </div>
    </div>
  );
}